import { render, staticRenderFns } from "./RequirementTable.vue?vue&type=template&id=60e7c1f5&scoped=true"
import script from "./RequirementTable.vue?vue&type=script&lang=js"
export * from "./RequirementTable.vue?vue&type=script&lang=js"
import style0 from "./RequirementTable.vue?vue&type=style&index=0&id=60e7c1f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7c1f5",
  null
  
)

export default component.exports